
import { computed, defineComponent, Ref } from "vue";

import { Navigation } from "@/core/modules/navigation/objects/Navigation";
import { useLocale } from "@/core/modules/locale/module";

export default defineComponent({
  name: "KoruBreadcrumb",
  props: {
    editRoute: { type: String, default: undefined },
    goBack: { type: Boolean, default: false },
    items: { type: Object, default: undefined },
    type: { type: String, default: "full" },
  },
  setup(props) {
    const { t } = useLocale();

    const classes: Record<string, boolean> = {
      card: true,
      "w-full": true,
      "xl:w-8": props.type == "boxed",
    };

    const home: Record<string, unknown> = {
      icon: "pi pi-home",
      to: "/",
    };

    const itemsRef: Ref<Record<string, unknown>[]> = computed(() => props.items as Record<string, unknown>[]);

    const goToBack = () => {
      Navigation.navigateBack();
    };

    const goToEdit = () => {
      if (props.editRoute === undefined) return;
      Navigation.navigateTo(props.editRoute);
    };

    return {
      classes,
      goToBack,
      goToEdit,
      home,
      itemsRef,
      t,
    };
  },
});
